export default __webpack_public_path__ + "static/media/cre-32.aaccc1a2.png";